import React from "react";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";

export default function RevisionLogBasicInfo(props) {

    const { historyLog } = props;

    const revisionInfo = { ...historyLog.details };
    delete revisionInfo.changes;
    delete revisionInfo.document;

    return (
        <Card className={"user-profile-card"}>
            <CardHeader color="rose">
                <h4>Revision info</h4>
            </CardHeader>
            <CardBody>
                <div>{JSON.stringify(revisionInfo, null, 2)}</div>
            </CardBody>
        </Card>
    );
}